/**
 * AreaMeContext — the guard's GET /area/me snapshot, shared with the area
 * pages so they don't re-fetch on every navigation. `refresh()` re-runs the
 * guard evaluation (e.g. after withdraw or the email-verified re-check).
 */

import { createContext, useContext } from 'react';
import type { AreaMe } from '@/lib/areaApi';

export interface AreaMeContextValue {
  me: AreaMe;
  refresh: () => void;
}

export const AreaMeContext = createContext<AreaMeContextValue | null>(null);

export function useAreaMe(): AreaMeContextValue {
  const value = useContext(AreaMeContext);
  if (!value) {
    throw new Error('useAreaMe must be used inside the AreaLayout shell');
  }
  return value;
}
